var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPauseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "LH-Z-003783_01_Image",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.51 36.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#414042;stroke-width:0px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.25,36.51C8.19,36.51,0,28.32,0,18.25S8.19,0,18.25,0s18.25,8.19,18.25,18.25-8.19,18.25-18.25,18.25ZM18.25,1.82C8.52,1.82.61,8.52.61,18.25s7.92,16.43,17.65,16.43,17.64-6.7,17.64-16.43S27.98,1.82,18.25,1.82Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.25,26.14c2.7-.07,2.83-1.19,2.83-3.72v-8.36c0-2.55-.03-3.6-2.83-3.7v-.74c1.66.05,3.35.07,4.98.07s3.32-.02,4.89-.07v.74c-2.75.15-2.83,1.14-2.83,3.7v8.38c0,2.5.07,3.62,2.8,3.69v.74c-2.28-.05-3.27-.07-5.01-.07-1.61,0-2.9.03-4.84.07v-.74Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.38,26.14c2.7-.07,2.83-1.19,2.83-3.72v-8.36c0-2.55-.03-3.6-2.83-3.7v-.74c1.66.05,3.35.07,4.98.07s3.32-.02,4.89-.07v.74c-2.75.15-2.83,1.14-2.83,3.7v8.38c0,2.5.07,3.62,2.8,3.69v.74c-2.28-.05-3.27-.07-5.01-.07-1.61,0-2.9.03-4.84.07v-.74Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseIcon);
export default __webpack_public_path__ + "static/media/pause-icon.93e443a69ced9ccc7b4548a9053e703d.svg";
export { ForwardRef as ReactComponent };